import { PerformedByRequestDTO } from './performed-by-request-dto';
import { TypeScopeDTO } from './type-scope-dto';

export interface ReadContextRoleScopeRequestDTO extends PerformedByRequestDTO {
    userEmail?: string;
    contextCd?: string;
    roleCd?: string;
    usage?: string;
    languageCd?: string;
    scope?: TypeScopeDTO[];
}
